// ----------------------------------------------------------------------
// V2 Modern Border Radius - More rounded for softer, contemporary feel

const shape = {
  borderRadius: 12,      // Base radius (inputs, chips)
  borderRadiusSm: 16,    // Small cards, buttons
  borderRadiusMd: 20,    // Standard cards
  borderRadiusLg: 24,    // Large panels, modals
  borderRadiusXl: 32     // Hero sections, feature cards
};

export default shape;
